import { useQuery } from '@tanstack/react-query';

import type { DashboardStats } from '@/api';
import APIGateway from '@/api';

export const dashboardKeys = {
  all: [ 'dashboard' ] as const,
  stats: () => [ ...dashboardKeys.all, 'stats' ] as const
};

export function useDashboardStatsQuery() {
  return useQuery( {
    queryKey: dashboardKeys.stats(),
    queryFn: async(): Promise<DashboardStats> => {
      return APIGateway.dashboard.dashboardStatsGet();
    },
    staleTime: 30000,
    retry: 1
  } );
}
